;(function () {
  const animateMegaMenu = (header) => {
    const menu = header.querySelector('.list-menu--inline')
    const menuLinks = Array.from(header.querySelectorAll('.list-menu-item'))
    const megaMenus = header.querySelectorAll('.mega-menu')
    const mobileMegaMenus = header.querySelectorAll('.mobile-mega-menu')

    if (!megaMenus || !menuLinks || menuLinks.length === 0 || megaMenus.length === 0) {
      return
    }

    const closeMenuDisclosure = () => {
      const disclosures = header.querySelectorAll('details-disclosure')
      if (customElements.get('details-disclosure')) {
        disclosures.forEach((disclosure) => {
          disclosure.close()
        })
      }

      const disclosureLists = header.querySelectorAll('.disclosure__list')
      disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true)
      })
    }

    const animateSubmenuLinks = (megaMenu) => {
      if (!megaMenu) return
      const submenu = megaMenu.querySelector('.mega-menu__submenu')
      const mediaBlocks = megaMenu.querySelectorAll('.mega-menu__media')
      if (!submenu) return
      const sublinks = submenu.querySelectorAll('.mega-menu__submenu-link')

      const removeActiveClass = () => {
        sublinks.forEach((sublink) => {
          sublink.classList.remove('mega-menu__submenu-link--active')
        })

        mediaBlocks.forEach((block) => {
          block.classList.remove('mega-menu__media--active')
          block.removeAttribute('style')
        })
      }

      const resetActiveClass = () => {
        removeActiveClass()
        sublinks[0]?.classList.add('mega-menu__submenu-link--active')
        if (mediaBlocks[0]) {
          mediaBlocks[0].classList.add('mega-menu__media--active')
          mediaBlocks[0].style.display = 'flex'
        }
      }

      const toggleActive = (sublink) => {
        if (sublink.classList.contains('mega-menu__submenu-link--active')) {
          return
        }
        removeActiveClass()
        sublink.classList.add('mega-menu__submenu-link--active')
        const tabId = sublink.getAttribute('data-mega-menu-tab-id')
        const needMedia = megaMenu.querySelector(`.mega-menu__media[data-mega-menu-tab-id='${tabId}']`)
        if (!needMedia) return
        needMedia.style.display = 'flex'
        setTimeout(() => {
          needMedia.classList.add('mega-menu__media--active')
        }, 150)
      }

      sublinks.forEach((sublink) => {
        sublink.addEventListener('mouseenter', () => {
          toggleActive(sublink)
        })
      })

      megaMenu.addEventListener('mouseleave', resetActiveClass)
    }

    const setDisplayStyles = (megaMenu) => {
      if (!megaMenu) return
      megaMenu.setAttribute('open', 'true')
      header.classList.add('header-sticky-with-opened-mega-menu')
      closeMenuDisclosure()
      animateSubmenuLinks(megaMenu)
    }

    const setHiddenStyles = (megaMenu) => {
      if (!megaMenu) return
      megaMenu.removeAttribute('open')
      header.classList.remove('header-sticky-with-opened-mega-menu')
    }

    const checkMenuPosition = (megaMenu) => {
      const modalWindow = megaMenu?.querySelector('.mega-menu__wrapper')
      if (!menu || !modalWindow) return
      const mainMenuRect = menu.getBoundingClientRect()
      const megaMenuRect = modalWindow.getBoundingClientRect()
      if (mainMenuRect.right > megaMenuRect.right) {
        const difWidth = 8 + mainMenuRect.right - megaMenuRect.right
        modalWindow.style.width = `calc(${difWidth}px + 1vw * 100 * 820 / 1440)`
      }
    }

    const checkScrollContainers = (megaMenu) => {
      const productBlocks = megaMenu.querySelectorAll('.mega-menu__products')
      const menuBlocks = megaMenu.querySelectorAll('.mega-menu__menu')
      const cardsBlocks = megaMenu.querySelectorAll('.mega-menu__cards-wrapper')

      productBlocks.forEach((block) => {
        if (block.scrollHeight > block.clientHeight) {
          block.classList.add('mega-menu__products--scroll')
        } else {
          block.classList.remove('mega-menu__products--scroll')
        }
      })

      menuBlocks.forEach((block) => {
        if (block.scrollHeight > block.clientHeight) {
          block.classList.add('mega-menu__menu--scroll')
        } else {
          block.classList.remove('mega-menu__menu--scroll')
        }
      })

      cardsBlocks.forEach((block) => {
        if (block.scrollHeight > block.clientHeight) {
          block.classList.add('mega-menu__cards-wrapper--scroll')
        } else {
          block.classList.remove('mega-menu__cards-wrapper--scroll')
        }
      })
    }

    const focusableSelector =
      "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])"
    let keyboardActiveLink = null

    const getMenuTrigger = (link) => link.querySelector('.header__menu-item')

    const getPanelForLink = (link, megaMenu = unifiedMegaMenu) => {
      if (!link || !megaMenu) return null

      const handle = link.getAttribute('data-menu-handle')
      return megaMenu.querySelector(`[data-menu-handle="${handle}"]`)
    }

    const getFocusableElements = (container) => {
      if (!container) return []

      return Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
        if (element.getAttribute('tabindex') === '-1') return false
        return element.getClientRects().length > 0
      })
    }

    const updateExpandedState = (activeLink = null) => {
      menuLinks.forEach((link) => {
        const trigger = getMenuTrigger(link)
        if (!trigger || !link.classList.contains('list-menu--megamenu')) return
        trigger.setAttribute('aria-expanded', link === activeLink ? 'true' : 'false')
      })
    }

    const resetKeyboardTabOrder = () => {
      keyboardActiveLink = null

      menuLinks.forEach((link) => {
        const trigger = getMenuTrigger(link)
        if (!trigger) return
        trigger.removeAttribute('tabindex')
      })

      if (unifiedMegaMenu) {
        unifiedMegaMenu.querySelectorAll('.mega-menu__menu-list-link').forEach((link) => {
          link.removeAttribute('tabindex')
        })
      }

      updateExpandedState()
    }

    const setKeyboardTabOrder = (activeLink) => {
      if (!activeLink) {
        resetKeyboardTabOrder()
        return
      }

      keyboardActiveLink = activeLink
      const activeIndex = menuLinks.indexOf(activeLink)
      const activePanel = getPanelForLink(activeLink)

      menuLinks.forEach((link, index) => {
        const trigger = getMenuTrigger(link)
        if (!trigger) return

        if (index > activeIndex) {
          trigger.tabIndex = -1
        } else {
          trigger.removeAttribute('tabindex')
        }
      })

      unifiedMegaMenu.querySelectorAll('.mega-menu__menu-list-link').forEach((link) => {
        if (activePanel?.contains(link)) {
          link.removeAttribute('tabindex')
        } else {
          link.tabIndex = -1
        }
      })

      updateExpandedState(activeLink)
    }

    const applyCtaTabTarget = (ctaBtn, activeTab) => {
      const shouldOpenBlank = activeTab.getAttribute('data-tab-target-blank') === 'true'
      if (shouldOpenBlank) {
        ctaBtn.target = '_blank'
        ctaBtn.rel = 'noopener noreferrer'
      } else {
        ctaBtn.removeAttribute('target')
        ctaBtn.removeAttribute('rel')
      }
    }

    const syncCtaWithActiveTab = (panel) => {
      const activeTab =
        panel.querySelector('.mega-menu__tab-panel--active') || panel.querySelector('.mega-menu__tab-panel')
      const ctaBtn = panel.closest('.mega-menu__block')?.querySelector('[data-mega-cta]')
      if (ctaBtn && activeTab) {
        const tabUrl = activeTab.getAttribute('data-tab-url')
        const tabTitle = activeTab.getAttribute('data-tab-title')
        if (tabUrl) ctaBtn.href = tabUrl
        if (tabTitle) ctaBtn.textContent = 'SHOP ' + tabTitle.toUpperCase()
        applyCtaTabTarget(ctaBtn, activeTab)
      }
    }

    const openMegaMenu = (link, options = {}) => {
      const { keyboardNavigation = false } = options
      if (!link.classList.contains('list-menu--megamenu')) return
      link.classList.add('list-menu--megamenu-visible')
      if (!unifiedMegaMenu) return

      clearMenuWrapperReset()

      const menuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
      const contentPanels = unifiedMegaMenu.querySelectorAll('.mega-menu__content-panel')

      // Hide all panels
      contentPanels.forEach((panel) => {
        panel.style.display = 'none'
      })

      // Show the target panel
      const targetPanel = getPanelForLink(link)
      if (targetPanel) {
        targetPanel.style.display = 'block'

        if (targetPanel.classList.contains('mega-menu__content-panel--tabbed')) {
          menuWrapper.classList.add('mega-menu__wrapper--wide')
          menuWrapper.style.removeProperty('transform')
          const tabbedPanel = targetPanel
            .closest('.mega-menu__block')
            ?.querySelector('.mega-menu__content-panel--tabbed')
          if (tabbedPanel) syncCtaWithActiveTab(tabbedPanel)
        } else {
          menuWrapper.classList.remove('mega-menu__wrapper--wide')
          const linkRect = link.getBoundingClientRect()
          const navRect = menu.getBoundingClientRect()
          const linkCenter = linkRect.left + linkRect.width - navRect.left
          menuWrapper.style.transform = `translateX(${Math.max(linkCenter - menuWrapper.offsetWidth / 2 + 16, 0)}px)`
        }

        checkScrollContainers(unifiedMegaMenu)
        setDisplayStyles(unifiedMegaMenu)
        syncMenuWrapperHeight()
      }

      if (keyboardNavigation) {
        setKeyboardTabOrder(link)
      } else if (keyboardActiveLink && keyboardActiveLink !== link) {
        resetKeyboardTabOrder()
      }

      menuLinks.forEach((el) => {
        if (el !== link) {
          el.classList.remove('list-menu--megamenu-visible')
        }
      })
    }

    // Unified mega menu hover logic
    let hoverTimeout
    let menuWrapperResetHandler = null
    const HOVER_CLOSE_DELAY_MS = 120
    const unifiedMegaMenu = header.querySelector('.mega-menu--unified')
    if (!unifiedMegaMenu) return

    const syncMenuWrapperHeight = () => {
      const menuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
      if (!menuWrapper) return

      requestAnimationFrame(() => {
        menuWrapper.style.maxHeight = `${menuWrapper.scrollHeight}px`
      })
    }

    const clearMenuWrapperReset = () => {
      const menuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
      if (!menuWrapper || !menuWrapperResetHandler) return

      menuWrapper.removeEventListener('transitionend', menuWrapperResetHandler)
      menuWrapperResetHandler = null
    }

    const queueMenuWrapperReset = () => {
      const menuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
      if (!menuWrapper) return

      clearMenuWrapperReset()

      menuWrapperResetHandler = (event) => {
        if (event.target !== menuWrapper || event.propertyName !== 'max-height') return

        menuWrapper.removeEventListener('transitionend', menuWrapperResetHandler)
        menuWrapperResetHandler = null

        // Skip the reset if the menu was reopened before the close animation finished.
        if (unifiedMegaMenu.hasAttribute('open')) return

        menuWrapper.classList.remove('mega-menu__wrapper--wide')
        menuWrapper.style.removeProperty('transform')
      }

      menuWrapper.addEventListener('transitionend', menuWrapperResetHandler)
    }

    menuLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout)
        openMegaMenu(link)
      })
    })

    const resetDesktopTabs = () => {
      if (!unifiedMegaMenu) return
      unifiedMegaMenu.querySelectorAll('.mega-menu__content-panel--tabbed').forEach((panel) => {
        const btns = Array.from(panel.querySelectorAll('.mega-menu__tab-btn'))
        const panels = Array.from(panel.querySelectorAll('.mega-menu__tab-panel'))
        btns.forEach((btn, i) => {
          const isActive = i === 0
          btn.classList.toggle('mega-menu__tab-btn--active', isActive)
        })
        panels.forEach((p, i) => {
          const isActive = i === 0
          p.classList.toggle('mega-menu__tab-panel--active', isActive)
          p.style.display = isActive ? 'block' : 'none'
        })
        syncCtaWithActiveTab(panel)
      })
    }

    const activateDesktopTab = (btn) => {
      const tabId = btn.getAttribute('data-desktop-tab-id')
      const panel = btn.closest('.mega-menu__content-panel--tabbed')
      if (!panel) return

      panel.querySelectorAll('.mega-menu__tab-btn').forEach((t) => {
        t.classList.remove('mega-menu__tab-btn--active')
      })
      btn.classList.add('mega-menu__tab-btn--active')

      panel.querySelectorAll('.mega-menu__tab-panel').forEach((p) => {
        p.classList.remove('mega-menu__tab-panel--active')
        p.style.display = 'none'
      })
      const activeTab = panel.querySelector(`.mega-menu__tab-panel[data-desktop-tab-id="${tabId}"]`)
      if (activeTab) {
        activeTab.classList.add('mega-menu__tab-panel--active')
        activeTab.style.display = 'block'
      }

      const ctaBtn = panel.closest('.mega-menu__block').querySelector('[data-mega-cta]')
      if (ctaBtn && activeTab) {
        const tabUrl = activeTab.getAttribute('data-tab-url')
        const tabTitle = activeTab.getAttribute('data-tab-title')
        if (tabUrl) ctaBtn.href = tabUrl
        if (tabTitle) ctaBtn.textContent = 'SHOP ' + tabTitle.toUpperCase()
        applyCtaTabTarget(ctaBtn, activeTab)
      }

      syncMenuWrapperHeight()
    }

    const initDesktopTabs = () => {
      if (!unifiedMegaMenu) return
      unifiedMegaMenu.querySelectorAll('.mega-menu__tab-btn').forEach((btn) => {
        if (btn.dataset.desktopTabBound === 'true') return
        btn.addEventListener('mouseenter', () => activateDesktopTab(btn))
        btn.addEventListener('focus', () => activateDesktopTab(btn))
        btn.addEventListener('click', () => activateDesktopTab(btn))
        btn.dataset.desktopTabBound = 'true'
      })
    }

    initDesktopTabs()

    // Arrow-key navigation within the tabbed mega menu:
    //   ArrowDown on a tab              → first product/link in that tab's active panel
    //   ArrowLeft/Right on a card       → cycle focus through sibling cards in the grid
    //   ArrowDown on a card             → the "SHOP <collection>" CTA button
    //   ArrowUp on a card               → return focus to the active tab anchor
    //   ArrowUp/Down on a menu list link → cycle siblings, then escape to active tab / CTA
    //   ArrowUp on the CTA              → first product card (or last menu list link) in the panel
    unifiedMegaMenu.addEventListener('keydown', (event) => {
      if (window.innerWidth < 1100) return
      const target = event.target
      if (!(target instanceof HTMLElement)) return

      if (target.classList.contains('mega-menu__tab-btn') && event.key === 'ArrowDown') {
        const block = target.closest('.mega-menu__block')
        const activePanel = block?.querySelector('.mega-menu__tab-panel--active')
        const firstItem =
          activePanel?.querySelector('.mega-menu__product-card, .mega-menu__menu-list-link') ??
          block?.querySelector('.mega-menu__cta-btn')
        if (firstItem) {
          event.preventDefault()
          firstItem.focus()
        }
        return
      }

      if (target.classList.contains('mega-menu__product-card')) {
        const grid = target.closest('.mega-menu__products-grid')
        if (!grid) return

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          const cards = Array.from(grid.querySelectorAll('.mega-menu__product-card'))
          const idx = cards.indexOf(target)
          if (idx === -1) return
          const delta = event.key === 'ArrowRight' ? 1 : -1
          const next = cards[idx + delta]
          if (next) {
            event.preventDefault()
            next.focus()
          }
          return
        }

        if (event.key === 'ArrowDown') {
          const block = target.closest('.mega-menu__block')
          const ctaBtn = block?.querySelector('.mega-menu__cta-btn')
          if (ctaBtn) {
            event.preventDefault()
            ctaBtn.focus()
          }
          return
        }

        if (event.key === 'ArrowUp') {
          const block = target.closest('.mega-menu__content-panel--tabbed')
          const activeTabBtn = block?.querySelector('.mega-menu__tab-btn--active')
          if (activeTabBtn) {
            event.preventDefault()
            activeTabBtn.focus()
          }
          return
        }

        // Tab / Shift+Tab while inside a product card should move along the
        // tab bar (next/previous collection tab) rather than escaping the
        // mega menu entirely — the cards are only reachable via ArrowDown,
        // so Tab's natural flow (skip all tabindex=-1 items) would otherwise
        // land outside the header.
        if (event.key === 'Tab') {
          const block = target.closest('.mega-menu__content-panel--tabbed')
          if (!block) return
          const tabBtns = Array.from(block.querySelectorAll('.mega-menu__tab-bar .mega-menu__tab-btn'))
          const activeBtn = block.querySelector('.mega-menu__tab-btn--active')
          const activeIdx = activeBtn ? tabBtns.indexOf(activeBtn) : -1
          if (activeIdx === -1) return
          const nextIdx = activeIdx + (event.shiftKey ? -1 : 1)
          const nextBtn = tabBtns[nextIdx]
          if (nextBtn) {
            event.preventDefault()
            nextBtn.focus()
          }
          // If nextBtn is undefined (past the last tab or before the first),
          // let the browser handle Tab natively so the user can escape the
          // menu — the existing close-on-exit logic takes over.
        }
        return
      }

      if (target.classList.contains('mega-menu__menu-list-link')) {
        // Menu-list-link panels are vertical lists, so ArrowUp/Down cycles
        // siblings and escapes to the tab bar / CTA at the boundaries —
        // mirroring how product cards return focus to the tab/CTA axis.
        const tabbedBlock = target.closest('.mega-menu__content-panel--tabbed')
        if (!tabbedBlock) return

        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          const list = target.closest('.mega-menu__menu-list')
          const links = list ? Array.from(list.querySelectorAll('.mega-menu__menu-list-link')) : []
          const idx = links.indexOf(target)
          const delta = event.key === 'ArrowDown' ? 1 : -1
          const sibling = idx !== -1 ? links[idx + delta] : null
          if (sibling) {
            event.preventDefault()
            sibling.focus()
            return
          }

          event.preventDefault()
          if (event.key === 'ArrowUp') {
            const activeTabBtn = tabbedBlock.querySelector('.mega-menu__tab-btn--active')
            activeTabBtn?.focus()
          } else {
            const ctaBtn = tabbedBlock.closest('.mega-menu__block')?.querySelector('.mega-menu__cta-btn')
            ctaBtn?.focus()
          }
        }
        return
      }

      if (target.classList.contains('mega-menu__cta-btn') && event.key === 'ArrowUp') {
        const block = target.closest('.mega-menu__block')
        const activePanel = block?.querySelector('.mega-menu__tab-panel--active')
        const firstCard = activePanel?.querySelector('.mega-menu__product-card')
        if (firstCard) {
          event.preventDefault()
          firstCard.focus()
          return
        }
        const listLinks = activePanel?.querySelectorAll('.mega-menu__menu-list-link')
        const lastLink = listLinks && listLinks.length ? listLinks[listLinks.length - 1] : null
        if (lastLink) {
          event.preventDefault()
          lastLink.focus()
        }
      }
    })

    const closeMenu = () => {
      const menuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
      if (menuWrapper) {
        menuWrapper.style.maxHeight = '0px'
      }

      setHiddenStyles(unifiedMegaMenu)
      resetKeyboardTabOrder()
      resetDesktopTabs()
      queueMenuWrapperReset()
      menuLinks.forEach((link) => {
        link.classList.remove('list-menu--megamenu-visible')
      })
    }

    header.addEventListener('focusin', (event) => {
      if (window.innerWidth < 1100) return

      const target = event.target
      if (!(target instanceof HTMLElement)) return
      if (target.closest('.mega-menu__content-panel')) return

      const activeMenuLink = target.closest('.list-menu-item')
      if (activeMenuLink?.classList.contains('list-menu--megamenu')) {
        openMegaMenu(activeMenuLink, { keyboardNavigation: true })
        return
      }

      closeMenu()
    })

    header.addEventListener('focusout', () => {
      if (window.innerWidth < 1100) return

      requestAnimationFrame(() => {
        if (!header.contains(document.activeElement)) {
          closeMenu()
        }
      })
    })

    unifiedMegaMenu.addEventListener('keydown', (event) => {
      if (window.innerWidth < 1100 || event.key !== 'Tab' || event.shiftKey || !keyboardActiveLink) return

      const activePanel = getPanelForLink(keyboardActiveLink)
      const focusableLinks = getFocusableElements(activePanel)
      const lastLink = focusableLinks[focusableLinks.length - 1]

      if (!lastLink || event.target !== lastLink) return

      event.preventDefault()

      const activeIndex = menuLinks.indexOf(keyboardActiveLink)
      const nextMenuLink = menuLinks[activeIndex + 1]

      if (nextMenuLink) {
        closeMenu()
        getMenuTrigger(nextMenuLink)?.focus()
        return
      }

      const focusableElements = getFocusableElements(document)
      const currentIndex = focusableElements.indexOf(lastLink)
      const nextFocusable = currentIndex === -1 ? null : focusableElements[currentIndex + 1]

      closeMenu()
      nextFocusable?.focus()
    })

    // Close when leaving the header (nav area)
    header.addEventListener('mouseleave', () => {
      hoverTimeout = setTimeout(closeMenu, HOVER_CLOSE_DELAY_MS)
    })

    header.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout)
    })

    // Keep open when hovering mega menu wrapper (not the full-screen overlay element)
    const megaMenuWrapper = unifiedMegaMenu.querySelector('.mega-menu__wrapper')
    if (megaMenuWrapper) {
      megaMenuWrapper.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout)
      })

      // Close when leaving the visible panel, not the full-screen overlay
      megaMenuWrapper.addEventListener('mouseleave', () => {
        hoverTimeout = setTimeout(closeMenu, HOVER_CLOSE_DELAY_MS)
      })
    }

    // rename color swatch inputs ids and labels for unified desktop mega menu
    if (unifiedMegaMenu) {
      const allProductCards = unifiedMegaMenu.querySelectorAll('.mega-menu__products-card')

      allProductCards.forEach((productCard, index) => {
        const allSwatchInputs = productCard.querySelectorAll("input[type='radio']")
        const allSwatchLabels = productCard.querySelectorAll('label.color-swatch')

        allSwatchInputs.forEach((input) => {
          const oldId = input.id
          const oldName = input.name
          input.id = `${oldId}-unified-${index}`
          input.name = `${oldName}-unified-${index}`
        })
        allSwatchLabels.forEach((label) => {
          const oldFor = label.htmlFor
          label.htmlFor = `${oldFor}-unified-${index}`
        })
      })
    }

    // rename color swatch inputs ids and labels for mobile mega menu
    mobileMegaMenus.forEach((megaMenu, menuId) => {
      const allMobileItems = megaMenu.querySelectorAll('.mobile-mega-menu__item')

      if (!allMobileItems || allMobileItems.length === 0) return

      allMobileItems.forEach((item, itemId) => {
        item.querySelectorAll('.mobile-mega-menu__products-card').forEach((productCard) => {
          const allSwatchInputs = productCard.querySelectorAll("input[type='radio']")
          const allSwatchLabels = productCard.querySelectorAll('label.color-swatch')

          allSwatchInputs.forEach((input) => {
            const oldId = input.id
            const oldName = input.name
            input.id = `${oldId}-mob-mega${menuId}-item${itemId}`
            input.name = `${oldName}-mob-mega${menuId}-tab${itemId}`
          })
          allSwatchLabels.forEach((label) => {
            const oldFor = label.htmlFor
            label.htmlFor = `${oldFor}-mob-mega${menuId}-item${itemId}`
          })
        })
      })
    })
  }

  const closeMobileMenu = (header) => {
    const menuCloseBtn = header.querySelector('.header__modal-close-button')
    const mobileMenuDrawer = header.querySelector('header-drawer')
    if (!menuCloseBtn || !mobileMenuDrawer) return
    menuCloseBtn.addEventListener('click', (e) => {
      mobileMenuDrawer.closeMenuDrawer(e)
    })
  }

  const onHoverRemoveOverlay = (event) => {
    if (
      window.innerWidth < 1100 ||
      !event.target?.closest('.shopify-section-header') ||
      event.target.closest('.shopify-section-header-sticky') ||
      event.target.closest('.header-sticky-with-opened-mega-menu')
    ) {
      return
    }
    const header = event.target.closest('.shopify-section-header')
    header.classList.remove('color-background-overlay')
    header.classList.add('color-background-overlay-hidden')

    header.removeEventListener('mousemove', onMouseMove)
  }

  const onHoverAddOverlay = (event) => {
    if (
      window.innerWidth < 1100 ||
      !event.target?.classList.contains('shopify-section-header') ||
      event.target.classList.contains('shopify-section-header-sticky') ||
      event.target.classList.contains('header-sticky-with-opened-mega-menu')
    ) {
      return
    }
    const searchModal = document.querySelector('header-search.header__search')
    const burgerMenu = document.querySelector('burger-menu')
    if ((searchModal && searchModal.hasAttribute('open')) || (burgerMenu && burgerMenu.hasAttribute('opened'))) {
      return
    }
    event.target.classList.add('color-background-overlay')
    event.target.classList.remove('color-background-overlay-hidden')
  }

  const initHeaderOverlay = (header) => {
    const main = document.getElementById('MainContent')
    const sections = main.querySelectorAll('.shopify-section')

    if (sections.length > 0) {
      const sectionFirstChild = sections[0].querySelector("[data-header-overlay='true']")
      // selector with custom-liquid ".shopify-section-group-header-group, .shopify-section-group-overlay-group.custom-liquid-section"
      const headerGroupSections = document.querySelectorAll('.shopify-section-group-header-group')
      const breadcrumbs = document.querySelector('.breadcrumb')

      const removeColorScheme = (element) => {
        let classNames = element.getAttribute('class')
        classNames = classNames.replace(/color-background-\d+/g, '')
        element.setAttribute('class', classNames)
      }

      if (sectionFirstChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.add('section--has-overlay')
          sections[0].classList.remove('not-margin')
          header.classList.add('color-background-overlay')
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs)
            const colorScheme = sectionFirstChild.getAttribute('data-color-scheme')
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`)
          }
        } else {
          sections[0].classList.add('not-margin')
          header.classList.remove('color-background-overlay')
          header.removeEventListener('mouseenter', onHoverRemoveOverlay)
          header.removeEventListener('mouseleave', onHoverAddOverlay)
          if (breadcrumbs) removeColorScheme(breadcrumbs)
        }
      } else {
        header.classList.remove('color-background-overlay')
        header.removeEventListener('mouseenter', onHoverRemoveOverlay)
        header.removeEventListener('mouseleave', onHoverAddOverlay)
        if (breadcrumbs) removeColorScheme(breadcrumbs)
      }
    }
  }

  const onMouseMove = (event) => {
    onHoverRemoveOverlay(event)
  }

  const addListenersOnHeaderOverlay = (header) => {
    if (header && header.classList.contains('color-background-overlay')) {
      header.addEventListener('mouseenter', onHoverRemoveOverlay)
      header.addEventListener('mouseleave', onHoverAddOverlay)

      // get cursor position when page loading
      header.addEventListener('mousemove', onMouseMove)
    }
  }

  const initHeader = () => {
    const header = document.querySelector('.shopify-section-header')
    if (!header) return

    animateMegaMenu(header)
    closeMobileMenu(header)
    initHeaderOverlay(header)
    addListenersOnHeaderOverlay(header)
  }

  initHeader()

  document.addEventListener('shopify:section:load', initHeader)
  document.addEventListener('shopify:section:unload', initHeader)
  document.addEventListener('shopify:section:reorder', initHeader)
})()

class BurgerMenu extends HTMLElement {
  constructor() {
    super()
    this.header = document.querySelector('.header-wrapper')
    this.headerLogo = this.header.querySelector('.header__heading-link')
    this.burgerMenu = this.querySelector('.burger-menu')
    this.toggleBtn = this.querySelector('.burger-menu__toggle')
    this.isOpen = false

    if (this.header) this.header.preventHide = false

    this.setListeners()
  }

  open() {
    if (this.header) this.header.preventHide = true
    this.setAttribute('opened', 'true')
    document.body.classList.add('overflow-hidden-drawer')
    this.burgerMenu?.addEventListener('transitionend', () => trapFocus(this), {
      once: true,
    })
    this.isOpen = true
  }

  close() {
    document.body.classList.remove('overflow-hidden-drawer')
    this.removeAttribute('opened')
    if (this.header) this.header.preventHide = false
    this.isOpen = false
  }

  setListeners() {
    this.toggleBtn?.addEventListener('click', () => {
      if (this.isOpen) {
        this.close()
      } else {
        this.open()
      }
    })
    this.burgerMenu?.addEventListener('keyup', (event) => {
      event.code === 'Escape' && this.close()
    })

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 1100) {
          this.close()
        }
      })
    })

    resizeObserver.observe(this)
  }
}

if (!customElements.get('burger-menu')) {
  customElements.define('burger-menu', BurgerMenu)
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', class extends HTMLElement {})
}
